import React from 'react'
import './careers.css'

function CareersHeader() {
  return (

    
    <section className='careersHeader_header'>
        <div className='container careersHeader_main'>
             <div>
           <h1 className='careersHeader_title'>Careers</h1>
      
        <p className='careersHeader_info'>Open Positions</p>
     
        </div>
        </div>
    </section>
  )
}

export default CareersHeader
